var map = {
	"./Add.svg": [
		2453,
		2453
	],
	"./Alert.svg": [
		326,
		326
	],
	"./Bold.svg": [
		2261,
		2261
	],
	"./ChartBar.svg": [
		2475,
		2475
	],
	"./Check.svg": [
		9476,
		9476
	],
	"./ClockCounterClockwise.svg": [
		4612,
		4612
	],
	"./Close.svg": [
		3024,
		3024
	],
	"./CloseCircle.svg": [
		8580,
		8580
	],
	"./Copy.svg": [
		1035,
		1035
	],
	"./DataError.svg": [
		7102,
		7102
	],
	"./Dots.svg": [
		4672,
		4672
	],
	"./Edit.svg": [
		2552,
		2552
	],
	"./Eye-color.svg": [
		9185,
		9185
	],
	"./Eye-hide-color.svg": [
		3438,
		3438
	],
	"./Feedback.svg": [
		65,
		65
	],
	"./FeedbackHeart.svg": [
		8907,
		8907
	],
	"./FileDoc.svg": [
		3316,
		3316
	],
	"./H1.svg": [
		4642,
		4642
	],
	"./H2.svg": [
		4038,
		4038
	],
	"./H3.svg": [
		7863,
		7863
	],
	"./Image.svg": [
		6163,
		6163
	],
	"./Italic.svg": [
		3772,
		3772
	],
	"./Lightbulb.svg": [
		4741,
		4741
	],
	"./Link.svg": [
		9212,
		9212
	],
	"./LinkBreak.svg": [
		1673,
		1673
	],
	"./LogoApp.svg": [
		1458,
		1458
	],
	"./Logout.svg": [
		2798,
		2798
	],
	"./MenuHamburguer.svg": [
		3201,
		3201
	],
	"./More.svg": [
		8719,
		8719
	],
	"./Next.svg": [
		5263,
		5263
	],
	"./Notepad.svg": [
		823,
		823
	],
	"./Notify.svg": [
		1359,
		1359
	],
	"./PencilSimple.svg": [
		9609,
		9609
	],
	"./Play.svg": [
		6114,
		6114
	],
	"./Previous.svg": [
		8107,
		8107
	],
	"./Record.svg": [
		2163,
		2163
	],
	"./Recruitment.svg": [
		2966,
		2966
	],
	"./Rotate.svg": [
		9529,
		9529
	],
	"./Settings.svg": [
		6299,
		6299
	],
	"./SmallGreenCheck.svg": [
		4478,
		4478
	],
	"./SmallLoading.svg": [
		4127,
		4127
	],
	"./Target.svg": [
		5471,
		5471
	],
	"./Text.svg": [
		7833,
		7833
	],
	"./TrafficCone.svg": [
		2710,
		2710
	],
	"./Trash.svg": [
		2706,
		2706
	],
	"./TreeStructure-setor.svg": [
		2635,
		2635
	],
	"./Tv.svg": [
		4838,
		4838
	],
	"./Underline.svg": [
		1352,
		1352
	],
	"./UploadSimple.svg": [
		8197,
		8197
	],
	"./Users.svg": [
		1076,
		1076
	],
	"./WarningCircle.svg": [
		4404,
		4404
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9715;
module.exports = webpackAsyncContext;